import { config } from '@uhg-abyss/web/tools/config';

import appConfig from './app.json';
import localConfig from './env/local.json';
import testConfig from './env/test.json';
import stageConfig from './env/stage.json';
import releaseConfig from './env/release.json';
import prodConfig from './env/prod.json';

const envs = {
  local: localConfig,
  test: testConfig,
  stage: stageConfig,
  release: releaseConfig,
  prod: prodConfig,
};

config({ ...appConfig, ...envs[config('APP_ENV')] });
